export const pathName = process.env.REACT_APP_PATHNAME;
export default pathName;

// novo servidor alterar domain no env e homepage no package.json, homolog.
